package com.yendo.mx.utils

import com.yendo.mx.models.ConfiguracionZona
import com.yendo.mx.utils.getAhora
import kotlinx.datetime.*

object LogisticaUtils {

    /**
     * Convierte una cadena "HH:mm" a minutos totales del día
     */
    fun aMinutos(hora: String): Int {
        return try {
            val parts = hora.split(":")
            if (parts.size == 2) {
                parts[0].toInt() * 60 + parts[1].toInt()
            } else 0
        } catch (e: Exception) {
            0
        }
    }

    /**
     * Verifica si la plataforma Yendo está operativa (Basado puramente en Horario Semanal)
     */
    fun estaPlataformaAbierta(config: ConfiguracionZona?): Boolean {
        if (config == null) return true
        
        // El Horario Semanal es ahora la única fuente de verdad
        val zonaHoraria = TimeZone.currentSystemDefault()
        val ahora = Instant.fromEpochMilliseconds(getAhora()).toLocalDateTime(zonaHoraria)
        
        return esHorarioValido(ahora, config.operacion.horario_semanal)
    }

    /**
     * Mapea DayOfWeek de Kotlin a las llaves en español de Firestore
     */
    fun obtenerNombreDiaEspanol(day: DayOfWeek): String {
        return when(day) {
            DayOfWeek.MONDAY -> "LUNES"
            DayOfWeek.TUESDAY -> "MARTES"
            DayOfWeek.WEDNESDAY -> "MIERCOLES"
            DayOfWeek.THURSDAY -> "JUEVES"
            DayOfWeek.FRIDAY -> "VIERNES"
            DayOfWeek.SATURDAY -> "SABADO"
            DayOfWeek.SUNDAY -> "DOMINGO"
            else -> ""
        }
    }

    /**
     * Valida si una fecha/hora específica está dentro del horario permitido
     */
    fun esHorarioValido(
        fechaObjetivo: LocalDateTime,
        horarioSemanal: Map<String, com.yendo.mx.models.HorarioDiario>
    ): Boolean {
        val nombreDia = obtenerNombreDiaEspanol(fechaObjetivo.dayOfWeek)
        val horarioDia = horarioSemanal[nombreDia] ?: return false
        if (!horarioDia.activo) return false

        val targetMinutos = fechaObjetivo.hour * 60 + fechaObjetivo.minute
        val aperturaMin = aMinutos(horarioDia.apertura)
        val cierreMin = aMinutos(horarioDia.cierre)

        return targetMinutos in aperturaMin..cierreMin
    }

    /**
     * Lógica de Intersección para Checkout
     * El pedido es posible si:
     * (Plataforma operativa OR tiene Flota Propia OR es PICKUP) AND (Negocio abierto)
     */
    fun validarDisponibilidad(
        config: ConfiguracionZona?,
        estaNegocioAbierto: Boolean,
        tipoPedido: String,
        tieneFlotaPropia: Boolean = false
    ): Boolean {
        // El Pickup ignora el cierre de la plataforma/logística, solo depende del negocio
        if (tipoPedido == "PICKUP") {
            return estaNegocioAbierto
        }

        // Para DELIVERY, el negocio debe estar abierto Y (Yendo plataforma activa O Flota Propia activa)
        val plataformaOk = estaPlataformaAbierta(config)
        val deliveryYendoOk = (config?.logistica?.delivery_activo ?: true) && plataformaOk
        val envioOk = deliveryYendoOk || tieneFlotaPropia

        return estaNegocioAbierto && envioOk
    }
}
